<script>
  import Layout from "../Layout/Layout.svelte";
  import config from "../stores/config";
  import axios from "axios";
  import { onMount } from "svelte";
  import { Circle } from "svelte-loading-spinners";
  import MenuHeading from "../shared/MenuHeading.svelte";
  import * as ls from "local-storage";
  import t from "../utils/t";

  let loading = true;
  let profile = null;
  let uploading = false;
  let uploadingPwd = false;

  let currentPassword;
  let newPassword;
  let confirmNewPassword;

  const loadSettings = () => {
    axios
      .get(`${$config.backendURL}/me`, {
        headers: { authorization: ls.get("jwt") },
      })
      .then((res) => {
        profile = res.data;
        loading = false;
      })
      .catch((err) => {
        loading = false;
        console.log(err);
      });
  };

  const handleSubmit = () => {
    uploading = true;
    axios
      .put(
        `${$config.backendURL}/users/${profile._id}`,
        { ...profile },
        { headers: { authorization: ls.get("jwt") } }
      )
      .then((res) => {
        alert(t({ en: "☑ Done Successfully", fr: "☑ Fait avec success" }));
        console.log(res);
        uploading = false;
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
        uploading = false;
      });
  };

  const handleSubmitNewPwd = () => {
    if (newPassword != confirmNewPassword) {
      alert(
        t({
          en: "New password & Confirm Password Don't match",
          fr: "Le nouveau mot de passe et le mot de passe confirmé ne sont pas identiques",
        })
      );
      return;
    }

    uploadingPwd = true;
    axios
      .put(
        `${$config.backendURL}/users/password/${profile._id}`,
        { currentPassword, newPassword },
        { headers: { authorization: ls.get("jwt") } }
      )
      .then((res) => {
        alert(t({ en: "☑ Done Successfully", fr: "☑ Fait avec success" }));
        console.log(res);
        uploadingPwd = false;
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
        uploadingPwd = false;
        alert(
          t({
            en: "Make sure your current password was entered correctly!",
            fr: "Votre mot de passe actuel n'a pas été inséré correctement!",
          })
        );
      });
  };

  onMount(() => {
    loadSettings();
  });
</script>

<svelte:head>
  <title>Profile | Fabi CC System</title>
</svelte:head>

<Layout>
  <MenuHeading
    title="Profile"
    description="Edit your profile information and change password. For security reasons, your **username** cannot be edited"
  />

  {#if loading}
    <div class="h-52 w-full flex items-center justify-center">
      <Circle size="50" color="rgb(16, 185, 129)" unit="px" />
    </div>
  {:else}
    <form
      on:submit|preventDefault={handleSubmit}
      class="grid grid-cols-1 gap-y-4 text-gray-500 pb-8"
    >
      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>{t({ en: "Full Name", fr: "Nom Complet" })}:</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="text"
            bind:value={profile.fullname}
            placeholder={t({ en: "Full Name", fr: "Nom Complet" })}
            required
          />
        </div>
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>{t({ en: "User Name", fr: "Nom d'utilisateur" })}:</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="text"
            bind:value={profile.username}
            placeholder={t({ en: "User Name", fr: "Nom d'utilisateur" })}
            required
            readonly
            disabled
          />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Email:</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="text"
            bind:value={profile.email}
            placeholder="Email"
            required
          />
        </div>
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Telephone:</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="text"
            bind:value={profile.tel}
            placeholder="Telephone"
            required
          />
        </div>
      </div>

      {#if uploading}
        <div class="grid grid-cols-1 gap-8">
          <div class="flex items-center justify-center btn btn-green">
            <Circle size="25" color="rgb(16, 185, 129)" unit="px" />
            <span class="ml-4"
              >{t({
                en: "Saving, Please Wait",
                fr: "Veuillez Patienter...",
              })}</span
            >
          </div>
        </div>
      {:else}
        <!-- else content here -->
        <div class="grid grid-cols-1 gap-8">
          <button class="btn btn-green">
            <i class="fas fa-check-circle mr-3" />
            {t({ en: "Update Profile", fr: "Sauvegarder Changements" })}
          </button>
        </div>
      {/if}
    </form>

    <!-- Change Password -->
    <!-- Change Password -->
    <!-- Change Password -->

    <h1 class="mt-12 text-gray-500 text-xl">
      {t({ en: "CHANGE YOUR PASSWORD", fr: "CHANGER MOT DE PASSE" })}:
    </h1>

    <form
      on:submit|preventDefault={handleSubmitNewPwd}
      class="mt-8 grid grid-cols-1 gap-y-4 text-gray-500 pb-8"
    >
      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>{t({ en: "Current Password", fr: "Mot de passe Actuel" })}:</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="password"
            bind:value={currentPassword}
            placeholder={t({
              en: "Current Password",
              fr: "Mot de passe actuel",
            })}
            required
          />
        </div>
        <!-- <div class="grid grid-cols-3 gap-2 items-center">
          <div>New Password:</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="password"
            bind:value={newPassword}
            placeholder="Username"
            required
          />
        </div> -->
      </div>

      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>
            {t({ en: "New Password", fr: "Nouveau mot de passe" })}:
          </div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="password"
            bind:value={newPassword}
            placeholder={t({
              en: "New Password",
              fr: "Nouveau mot de passe",
            })}
            required
          />
        </div>
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>
            {t({ en: "Confirm Password", fr: "Confirmer mot de passe" })}:
          </div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="password"
            bind:value={confirmNewPassword}
            placeholder={t({
              en: "Confirm Password",
              fr: "Confirmer mot de passe",
            })}
            required
          />
        </div>
      </div>

      {#if uploadingPwd}
        <div class="grid grid-cols-1 gap-8">
          <div class="flex items-center justify-center btn btn-green">
            <Circle size="25" color="rgb(16, 185, 129)" unit="px" />
            <span class="ml-4"
              >{t({
                en: "Saving, Please Wait",
                fr: "Veuillez Patienter...",
              })}</span
            >
          </div>
        </div>
      {:else}
        <!-- else content here -->
        <div class="grid grid-cols-1 gap-8">
          <button class="btn btn-green">
            <i class="fas fa-check-circle mr-3" />
            {t({
              en: "Update Password",
              fr: "Sauvegarder nouveau mot de passe",
            })}
          </button>
        </div>
      {/if}
    </form>
  {/if}
</Layout>
